import React, { useEffect, useState } from "react";
import "./armonizacionContable.css";
// Import Card component
import Card from "../Card/Card";

const articles = [
  // Artículo .

  {
    title: "42 LPEEH 2019",
    link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_42_LPEEH_2019.pdf",
    year: 2019,
  },
  {
    title: "41 LPEEH 2020",
    link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_41_LPEEH_2020.pdf",
    year: 2020,
  },
  {
    title: "39 LPEEH 2021",
    link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_39_LPEEH_2021.pdf",
    year: 2021,
  },
  {
    title: "39 LPEEH 2022",
    link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_39_LPEEH_2022.pdf",
    year: 2022,
  },
  {
    title: "39 LPEEH 2023",
    link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_39_LPEEH_2023.pdf",
    year: 2023,
  },
  {
    title: "39 LPEEH 2024",
    link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_39_LPEEH_2024.pdf",
    year: 2024,
  },
  {
    title: "39 LPEEH 2025",
    link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_39_LPEEH_2025.pdf",
    year: 2025,
  },
  {
    title: "39 LPEEH 2026",
    link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Articulo_39_LPEEH_2026.pdf",
    year: 2026,
  },
];

function ArmonizacionContable() {
  return (
    <>
      <div className="container py-4">
        <div className="secretaria_funciones">
          <h3 className="title">Armonización Contable</h3>
          <hr className="hr-gob" />
        </div>
        <div className="container m-auto">
          <MyTable />
        </div>
        <div className="secretaria_funciones">
          <h3 className="title">Calendario Anual Autorizado</h3>
          <hr className="hr-gob" />
        </div>
        <div className="row">
          {articles.map((article, i) => (
            <Card
              key={i}
              document={"Artículo"}
              title={article.title}
              href={article.link}
              type="PDF"
              year={article.year}
            />
          ))}
        </div>
      </div>
    </>
  );
}

function MyTable() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [data, setData] = useState([
    [
      "Año",
      "2026",
      "2025",
      "2024",
      "2023",
      "2022",
      "2021",
      "2020",
      "2019",
      "2018",
    ],
    [
      "Información Trimestral",
         {
        text: "PDF",
        link: "/CAASIM/armonizacion/trimestral/2026/trimestral 2026.pdf",
      },
      {
        text: "PDF",
        link: "/CAASIM/armonizacion/trimestral/2025/trimestral 2025.pdf",
      },
      {
        text: "PDF",
        link: "/CAASIM/armonizacion/trimestral/2024/trimestral 2024.pdf",
      },
      {
        text: "PDF",
        link: "/CAASIM/armonizacion/trimestral/2023/trimestral 2023.pdf",
      },
      {
        text: "PDF",
        link: "/CAASIM/armonizacion/trimestral/2022/trimestral 2022.pdf",
      },
      {
        text: "PDF",
        link: "/CAASIM/armonizacion/trimestral/2021/trimestral 2021.pdf",
      },
      {
        text: "PDF",
        link: "/CAASIM/armonizacion/trimestral/2020/trimestral 2020.pdf",
      },
      {
        text: "PDF",
        link: "/CAASIM/armonizacion/trimestral/2019/trimestral 2019.pdf",
      },
      {
        text: "PDF",
        link: "/CAASIM/armonizacion/trimestral/2018/trimestral 2018.pdf",
      },
    ],
    [
      "Información Anual",
      { text: "PDF", link: "/CAASIM/armonizacion/anual/2026/anual 2026.pdf" },
      { text: "PDF", link: "/CAASIM/armonizacion/anual/2025/anual 2025.pdf" },
      { text: "PDF", link: "/CAASIM/armonizacion/anual/2024/anual 2024.pdf" },
      { text: "PDF", link: "/CAASIM/armonizacion/anual/2023/anual 2023.pdf" },
      { text: "PDF", link: "/CAASIM/armonizacion/anual/2022/anual 2022.pdf" },
      { text: "PDF", link: "/CAASIM/armonizacion/anual/2021/anual 2021.pdf" },
      { text: "PDF", link: "/CAASIM/armonizacion/anual/2020/anual 2020.pdf" },
      { text: "PDF", link: "/CAASIM/armonizacion/anual/2019/anual 2019.pdf" },
      { text: "PDF", link: "/CAASIM/armonizacion/anual/2018/anual 2018.pdf" },
    ],
  ]);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);

    // Call listener once to detect initial window size
    checkMobile();

    // Set event listener for window resizing
    window.addEventListener("resize", checkMobile);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", checkMobile);
  }, []); // Empty dependency array ensures this runs on mount and unmount only

  useEffect(() => {
    if (isMobile) {
      const transpose = (matrix) =>
        matrix[0].map((_, i) => matrix.map((row) => row[i]));

      setData((prevState) => transpose(prevState));
    }
  }, [isMobile]);
  return (
    <>
      <table className="table mb-5">
        <thead>
          <tr>
            {data[0].map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.slice(1).map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j}>
                  {typeof cell === "object" && cell.text === "PDF" ? (
                    cell.link === "#" ? (
                      <span>{cell.text}</span>
                    ) : (
                      <a
                        href={cell.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {cell.text}
                      </a>
                    )
                  ) : (
                    cell
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

// const ArticleCard = ({ title, link }) => (
//   <div className="col-md-3 col-sm-6 col-12">
//     <div className="card_container_historicos">
//       <div className="card_anio">
//         <h5>Artículo</h5>
//         <div className="card_trimestre">
//           <p>
//             {title}
//             <span className="badge bg-secondary">
//               <a href={link} target="_blank" rel="noreferrer">
//                 PDF
//               </a>
//             </span>
//           </p>
//         </div>
//       </div>
//     </div>
//   </div>
// );

 export default ArmonizacionContable;



// import React, { useState } from "react";
// import "./armonizacionContable.css";
// // Import del componente Card para la sección de Calendario Anual
// import Card from "../Card/Card";

// // Array de artículos para el Calendario Anual Autorizado
// const articles = [
//   {
//     title: "42 LPEEH 2019",
//     link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_42_LPEEH_2019.pdf",
//     year: 2019,
//   },
//   {
//     title: "41 LPEEH 2020",
//     link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_41_LPEEH_2020.pdf",
//     year: 2020,
//   },
//   {
//     title: "39 LPEEH 2021",
//     link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_39_LPEEH_2021.pdf",
//     year: 2021,
//   },
//   {
//     title: "39 LPEEH 2022",
//     link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_39_LPEEH_2022.pdf",
//     year: 2022,
//   },
//   {
//     title: "39 LPEEH 2023",
//     link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_39_LPEEH_2023.pdf",
//     year: 2023,
//   },
//   {
//     title: "39 LPEEH 2024",
//     link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_39_LPEEH_2024.pdf",
//     year: 2024,
//   },
//   {
//     title: "39 LPEEH 2025",
//     link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Artículo_39_LPEEH_2025.pdf",
//     year: 2025,
//   },
//   {
//     title: "39 LPEEH 2026",
//     link: "/CAASIM/Armonizacion/_Calendario Anual Autorizado/Articulo_39_LPEEH_2026.pdf",
//     year: 2026,
//   },
// ];

// function ArmonizacionContable() {
//   const [openAnio, setOpenAnio] = useState(null);
//   const [openTrimestre, setOpenTrimestre] = useState(null);
//   const [openCategoria, setOpenCategoria] = useState(null);
//   const [vistaAnio, setVistaAnio] = useState({});

//   const toggleAnio = (anio) => {
//     setOpenAnio(openAnio === anio ? null : anio);
//   };

//   const toggleTrimestre = (id) => {
//     setOpenTrimestre(openTrimestre === id ? null : id);
//   };

//   const toggleCategoria = (idCat) => {
//     setOpenCategoria(openCategoria === idCat ? null : idCat);
//   };

//   const cambiarVista = (anio, tipo) => {
//     setVistaAnio((prev) => ({
//       ...prev,
//       [anio]: prev[anio] === tipo ? null : tipo,
//     }));
//   };

//   const esExcel = (ruta) => Boolean(ruta && /\.xlsx?$/i.test(ruta));

//   const obtenerEtiquetaBadge = (ruta) => {
//     if (esExcel(ruta)) {
//       return "Descargar Excel";
//     }
//     return "Abrir Archivo";
//   };

//   const obtenerRutaSegura = (ruta) => {
//     if (!ruta) return "#";
//     try {
//       return encodeURI(ruta);
//     } catch {
//       return encodeURI(encodeURI(ruta));
//     }
//   };

//   const esRespuestaHtml = async (response) => {
//     const contentType = response.headers.get("content-type") || "";
//     if (contentType.includes("text/html")) return true;

//     const clone = response.clone();
//     const text = await clone.text();
//     return (
//       text.trim().startsWith("<!DOCTYPE html") ||
//       text.includes("<html") ||
//       text.includes("You need to enable JavaScript")
//     );
//   };

//   const intentarAbrirODescargar = async (rutaCandidata, nombreOriginal) => {
//     try {
//       const rutaCodificada = obtenerRutaSegura(rutaCandidata);
//       const response = await fetch(rutaCodificada, { method: "GET" });

//       if (!response.ok) return false;

//       const esHtml = await esRespuestaHtml(response);
//       if (esHtml) return false;

//       const contentType = response.headers.get("content-type") || "";
//       const esPdfReal = contentType.includes("pdf") || /\.pdf$/i.test(rutaCandidata);

//       if (esPdfReal) {
//         window.open(rutaCodificada, "_blank", "noopener,noreferrer");
//         return true;
//       } else {
//         const blobData = await response.blob();
//         const esXls = /\.xls$/i.test(rutaCandidata);
//         const mimeType = esXls
//           ? "application/vnd.ms-excel"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

//         const blob = new Blob([blobData], { type: mimeType });
//         const downloadUrl = window.URL.createObjectURL(blob);

//         const link = document.createElement("a");
//         link.href = downloadUrl;
//         const nombreArchivoFinal = rutaCandidata.split("/").pop() || nombreOriginal;
//         link.setAttribute("download", nombreArchivoFinal);

//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(downloadUrl);

//         return true;
//       }
//     } catch (err) {
//       return false;
//     }
//   };

//   const manejarClicArchivo = async (e, ruta, nombre) => {
//     if (e) e.preventDefault();
//     if (!ruta) return;

//     try {
//       const variantes = [ruta];
//       const rutaSinAcentos = ruta.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

//       if (/\.xlsx?$/i.test(ruta)) {
//         variantes.push(ruta.replace(/\.xlsx?$/i, ".pdf"));
//         if (ruta.endsWith(".xls")) variantes.push(ruta.replace(/\.xls$/, ".xlsx"));
//         if (ruta.endsWith(".xlsx")) variantes.push(ruta.replace(/\.xlsx$/, ".xls"));
//       } else if (/\.pdf$/i.test(ruta)) {
//         variantes.push(ruta.replace(/\.pdf$/i, ".xlsx"));
//         variantes.push(ruta.replace(/\.pdf$/i, ".xls"));
//       }

//       if (rutaSinAcentos !== ruta) {
//         variantes.push(rutaSinAcentos);
//         if (/\.xlsx?$/i.test(rutaSinAcentos)) {
//           variantes.push(rutaSinAcentos.replace(/\.xlsx?$/i, ".pdf"));
//         } else if (/\.pdf$/i.test(rutaSinAcentos)) {
//           variantes.push(rutaSinAcentos.replace(/\.pdf$/i, ".xlsx"));
//           variantes.push(rutaSinAcentos.replace(/\.pdf$/i, ".xls"));
//         }
//       }

//       const variantesUnicas = [...new Set(variantes)];

//       let exito = false;
//       for (const rutaPrueba of variantesUnicas) {
//         exito = await intentarAbrirODescargar(rutaPrueba, nombre);
//         if (exito) break;
//       }

//       if (!exito) {
//         alert(`Atención: El archivo "${nombre}" aún no está disponible o no se encuentra en el servidor para este periodo.`);
//       }
//     } catch (error) {
//       alert(`Atención: El archivo "${nombre}" no está disponible para el periodo seleccionado.`);
//     }
//   };

//   // Estructura de Secciones TRIMESTRALES
//   const crearSeccionesTrimestrales = (anio, identificador) => {
//     const basePath = `/CAASIM/armonizacion/Trimestral/${anio}/${identificador}`;

//     return [
//       {
//         categoria: "I.- Estados e Información Contable",
//         incisos: [
//           { letra: "a)", nombre: "Estado de Actividades", pdf: `${basePath}/I. Estados e Informacion Contable/a) Estado de Actividades.pdf` },
//           { letra: "b)", nombre: "Estado de Situación Financiera", pdf: `${basePath}/I. Estados e Informacion Contable/b) Estado de Situacion Financiera.pdf` },
//           { letra: "c)", nombre: "Estado de Variación en la Hacienda Pública", pdf: `${basePath}/I. Estados e Informacion Contable/c) Estado de Variacion en la Hacienda Publica.pdf` },
//           { letra: "d)", nombre: "Estado de Cambios en la Situación Financiera", pdf: `${basePath}/I. Estados e Informacion Contable/d) Estado de Cambios en la Situacion Financiera.pdf` },
//           { letra: "e)", nombre: "Estado de Flujos de Efectivo", pdf: `${basePath}/I. Estados e Informacion Contable/e) Estado de Flujos de Efectivo.pdf` },
//           { letra: "f)", nombre: "Estado Analítico del Activo", pdf: `${basePath}/I. Estados e Informacion Contable/f) Estado Analitico del Activo.pdf` },
//           { letra: "g)", nombre: "Estado Analítico de la Deuda y Otros Pasivos", pdf: `${basePath}/I. Estados e Informacion Contable/g) Estado Analitico de la Deuda y Otros Pasivos.pdf` },
//           { letra: "h)", nombre: "Informe Sobre Pasivos Contingentes", pdf: `${basePath}/I. Estados e Informacion Contable/h) Informe Sobre Pasivos Contingentes.pdf` },
//           { letra: "i)", nombre: "Notas a los Estados Financieros", pdf: `${basePath}/I. Estados e Informacion Contable/i) Notas a los Estados Financieros.pdf` }
//         ]
//       },
//       {
//         categoria: "II.- Estados e Informes Presupuestales",
//         incisos: [
//           { letra: "a)", nombre: "Estado Analítico de Ingresos incluyendo los ingresos excedentes Generados", pdf: `${basePath}/II. Estados e Informes Presupuestales/a) Estado Analitico de Ingresos.pdf` },
//           { letra: "b)", nombre: "1.1 Estado Analítico del Ejercicio del Presupuesto de Egresos - Clasificacion Administrativa", pdf: `${basePath}/II. Estados e Informes Presupuestales/1.1 Estado Analitico del Ejercicio del Presupuesto de Egresos - Clasificacion Administrativa.pdf` },
//           { letra: "b)", nombre: "1.2 Estado Analítico del Ejercicio del Presupuesto de Egresos Identificado por Ramo", pdf: `${basePath}/II. Estados e Informes Presupuestales/1.2 Estado Analitico del Ejercicio del Presupuesto de Egresos Identificado por Ramo.pdf` },
//           { letra: "b)", nombre: "2. Estado Analítico del Ejercicio del Presupuesto de Egresos - Clasificacion Economica Tipo de Gasto", pdf: `${basePath}/II. Estados e Informes Presupuestales/2. Estado Analitico del Ejercicio del Presupuesto de Egresos - Clasificacion Economica Tipo de Gasto.pdf` },
//           { letra: "b)", nombre: "3. Estado Analítico del Ejercicio del Presupuesto de Egresos - Clasificacion por Objeto del Gasto", pdf: `${basePath}/II. Estados e Informes Presupuestales/3. Estado Analitico del Ejercicio del Presupuesto de Egresos - COG.pdf` },
//           { letra: "b)", nombre: "4. Estado Analítico del Ejercicio del Presupuesto de Egresos - Clasificacion Funcional", pdf: `${basePath}/II. Estados e Informes Presupuestales/4. Estado Analitico del Ejercicio del Presupuesto de Egresos - Clasificacion Funcional.pdf` },
//           { letra: "c)", nombre: "Endeudamiento Neto", pdf: `${basePath}/II. Estados e Informes Presupuestales/c) Endeudamiento Neto.pdf` },
//           { letra: "d)", nombre: "Intereses de la Deuda", pdf: `${basePath}/II. Estados e Informes Presupuestales/d) Intereses de la Deuda.pdf` },
//           { letra: "e)", nombre: "Flujo de Fondos", pdf: `${basePath}/II. Estados e Informes Presupuestales/e) Flujo de Fondos.pdf` }
//         ]
//       },
//       {
//         categoria: "III.- Estados e Informes Programáticos",
//         incisos: [
//           { letra: "a)", nombre: "Gasto por Categoria Programatica", pdf: `${basePath}/III. Estados de Informes Programaticos/a) Gasto por Categoria Programatica.pdf` },
//           { letra: "b)", nombre: "Programas y Proyectos de Inversion", pdf: `${basePath}/III. Estados de Informes Programaticos/b) Programas y Proyectos de Inversion.pdf` },
//           { letra: "c)", nombre: "Indicadores de Resultados", pdf: `${basePath}/III. Estados de Informes Programaticos/c) Indicadores de Resultados.pdf` }
//         ]
//       },
//       {
//         categoria: "IV.- Inventarios",
//         incisos: [
//           { letra: "a)", nombre: "Catalogo de Bienes Muebles", pdf: `${basePath}/IV. Inventarios/a) Catalogo de Bienes Muebles.xls` },
//           { letra: "b)", nombre: "Catalogo de Bienes Inmuebles", pdf: `${basePath}/IV. Inventarios/b) Catalogo de Bienes Inmuebles.xlsx` }
//         ]
//       },
//       {
//         categoria: "V.- Ejercicio Presupuestario",
//         incisos: [
//           { letra: "a)", nombre: "Montos Pagados por Ayudas y Subsidios", pdf: `${basePath}/V. Ejercicio Presupuestario/a) Montos Pagados por Ayudas y Subsidios.pdf` },
//           { letra: "b)", nombre: "Programas con Recursos Federales por Orden de Gobierno", pdf: `${basePath}/V. Ejercicio Presupuestario/b) Programas con Recursos Federales por Orden de Gobierno.pdf` },
//           { letra: "c)", nombre: "Fondo de Aportaciones para la Educacion Tecnologica y de Adultos", pdf: `${basePath}/V. Ejercicio Presupuestario/c) Fondo de Aportaciones para la Educacion Tecnologica y de Adultos.pdf` },
//           { letra: "d)", nombre: "Aportaciones Federales en Materia de Salud", pdf: `${basePath}/V. Ejercicio Presupuestario/d) Aportaciones Federales en Materia de Salud.pdf` },
//           { letra: "e)", nombre: "Fondo de Aportaciones para la Infraestructura Social", pdf: `${basePath}/V. Ejercicio Presupuestario/e) Fondo de Aportaciones para la Infraestructura Social.pdf` },
//           { letra: "f)", nombre: "Fondo de Aportaciones para el Fortalecimiento de los Municipios y de las Demarcaciones Territoriales del Distrito Federal (FORTAMUN)", pdf: `${basePath}/V. Ejercicio Presupuestario/f) Fondo de Aportaciones (FORNATUM).pdf` },
//           { letra: "g)", nombre: "Fondos de Ayuda Federal para la Seguridad Publica", pdf: `${basePath}/V. Ejercicio Presupuestario/g) Fondos de Ayuda Federal para la Seguridad Publica.pdf` },
//           { letra: "h)", nombre: "Obligaciones Pagadas o Garantizadas con Fondos Federales", pdf: `${basePath}/V. Ejercicio Presupuestario/h) Obligaciones Pagadas o Garantizadas con Fondos Federales.pdf` },
//           { letra: "i)", nombre: "Ejercicio y Destino del Gasto Federalizado", pdf: `${basePath}/V. Ejercicio Presupuestario/i) Ejercicio y Destino del Gasto Federalizado.pdf` },
//           { letra: "j)", nombre: "Difusion de los Resultados de las Evaluaciones de los Recursos Federales Ministrados a las Entidades Federativas", pdf: `${basePath}/V. Ejercicio Presupuestario/j) Evaluacion de Recursos Federales.pdf` }
//         ]
//       },
//       {
//         categoria: "VI.- Criterios Ley de Disciplina Financiera",
//         incisos: [
//           { letra: "Formato 1)", nombre: "Estado de Situacion Financiera Detallado", pdf: `${basePath}/VI. Criterios Ley de Disciplina Financiera/Formato 1) Estado de Situacion Financiera Detallado.xls` },
//           { letra: "Formato 2)", nombre: "Informe Analitico Deuda Publica y Otros Pasivos", pdf: `${basePath}/VI. Criterios Ley de Disciplina Financiera/Formato 2) Informe Analitico Deuda Publica y Otros Pasivos.xls` },
//           { letra: "Formato 3)", nombre: "Informe Analitico de Obligaciones Diferentes Financiamientos", pdf: `${basePath}/VI. Criterios Ley de Disciplina Financiera/Formato 3) Informe Analitico de Obligaciones Diferentes Financiamientos.xls` },
//           { letra: "Formato 4)", nombre: "Balance Presupuestario", pdf: `${basePath}/VI. Criterios Ley de Disciplina Financiera/Formato 4) Balance Presupuestario.xls` },
//           { letra: "Formato 5)", nombre: "Estado Analitico de Ingresos Detallado", pdf: `${basePath}/VI. Criterios Ley de Disciplina Financiera/Formato 5) Estado Analitico de Ingresos Detallado.xls` },
//           {
//             letra: "Formato 6)",
//             nombre: "Estado Analítico del Ejercicio del Presupuesto de Egresos Detallado:",
//             subIncisos: [
//               { letra: "a)", nombre: "Clasificacion por Objeto del Gasto", pdf: `${basePath}/VI. Criterios Ley de Disciplina Financiera/Formato 6a) Clasificacion por Objeto del Gasto.xls` },
//               { letra: "b)", nombre: "Clasificacion Administrativa", pdf: `${basePath}/VI. Criterios Ley de Disciplina Financiera/Formato 6b) Clasificacion Administrativa.xls` },
//               { letra: "c)", nombre: "Clasificacion Funcional", pdf: `${basePath}/VI. Criterios Ley de Disciplina Financiera/Formato 6c) Clasificacion Funcional.xls` },
//               { letra: "d)", nombre: "Clasificacion de Servicios Personales por Categoria", pdf: `${basePath}/VI. Criterios Ley de Disciplina Financiera/Formato 6d) Clasificacion de Servicios Personales por Categoria.pdf` }
//             ]
//           }
//         ]
//       }
//     ];
//   };

//   // Estructura de Secciones ANUALES
//   const crearSeccionesAnuales = (anio) => {
//     const basePath = `/CAASIM/armonizacion/Anual/${anio}/Ejercicio${anio}`;

//     return [
//       {
//         categoria: `I. Iniciativas y Proyectos ${anio}`,
//         incisos: [
//           {
//             letra: "A.",
//             nombre: `Iniciativa de Ingresos ${anio}`,
//             subIncisos: [
//               { letra: "a.1", nombre: `Criterios Generales de Ingresos ${anio}`, pdf: `${basePath}/I. Iniciativas y Proyectos/a.1.Criterios Generales de Ingresos para el Ejercicio Fiscal.pdf` },
//               { letra: "a.2", nombre: `Presentación de Ingresos Estimados ${anio}`, pdf: `${basePath}/I. Iniciativas y Proyectos/a.2 Ingresos estimados.pdf` },
//               { letra: "a.3", nombre: `Acuerdo Tarifario ${anio}`, pdf: `${basePath}/I. Iniciativas y Proyectos/a.3.Propuesta de Acuerdo Tarifario.pdf` }
//             ]
//           },
//           { letra: "B.", nombre: `Información Adicional a la Iniciativa de Ingresos ${anio}`, pdf: `${basePath}/I. Iniciativas y Proyectos/B. Informacion Adicional a la Iniciativa de Ingresos.pdf` },
//           {
//             letra: "C.",
//             nombre: `Proyecto de Presupuesto de Egresos ${anio}`,
//             subIncisos: [
//               { letra: "c.1", nombre: `Criterios Generales de Egresos ${anio}`, pdf: `${basePath}/I. Iniciativas y Proyectos/c.1.Criterios Generales de Egresos.pdf` }
//             ]
//           },
//           { letra: "D.", nombre: `Información Adicional al Proyecto de Presupuesto de Egresos ${anio}`, pdf: `${basePath}/I. Iniciativas y Proyectos/D. Informacion Adicional al Proyecto de Presupuesto de Egresos.xlsx` }
//         ]
//       },
//       {
//         categoria: `II. Ley de Ingresos y Ley de Egresos ${anio}`,
//         incisos: [
//           { letra: "A.", nombre: `Presupuesto Ciudadano ${anio}`, pdf: `${basePath}/II. Ley de Ingresos y Ley de Egresos/a. Presupuesto Ciudadano.pdf` },
//           {
//             letra: "B.",
//             nombre: "Ley de Ingresos",
//             subIncisos: [
//               { letra: "b.1", nombre: `Criterios Generales de Ingresos ${anio}`, pdf: `${basePath}/II. Ley de Ingresos y Ley de Egresos/b.1 Criterios Generales de Ingresos.pdf` },
//               { letra: "b.2", nombre: `Decreto que Aprueba Cuotas y Tarifas ${anio}`, pdf: `${basePath}/II. Ley de Ingresos y Ley de Egresos/b.2 Decreto Cuota y Tarifas.pdf` }
//             ]
//           },
//           {
//             letra: "C.",
//             nombre: "Presupuesto de Egresos",
//             subIncisos: [
//               { letra: "c.1", nombre: `Criterios Generales de Egresos ${anio}`, pdf: `${basePath}/II. Ley de Ingresos y Ley de Egresos/c.1 Criterios Generales de Egresos.pdf` }
//             ]
//           },
//           {
//             letra: "D.",
//             nombre: "Dictámenes, Acuerdos y Actas",
//             subIncisos: [
//               { letra: "d.1", nombre: `Acta Junta de Gobierno Anteproyecto Presupuesto de Ingresos y Egresos ${anio}`, pdf: `${basePath}/II. Ley de Ingresos y Ley de Egresos/d.1 Acta del anteproyecto de Ingresos y Egresos.pdf` },
//               { letra: "d.2", nombre: `Acta Junta de Gobierno Proyecto Presupuesto de Ingresos y Egresos ${anio}`, pdf: `${basePath}/II. Ley de Ingresos y Ley de Egresos/d.2 Acta Junta de Gobierno Proyecto Presupuesto.pdf` }
//             ]
//           },
//           { letra: "E.", nombre: `Calendario de ingresos ${anio}`, pdf: `${basePath}/II. Ley de Ingresos y Ley de Egresos/E. Calendario de Ingresos.xlsx` },
//           { letra: "F.", nombre: `Calendario de Egresos ${anio}`, pdf: `${basePath}/II. Ley de Ingresos y Ley de Egresos/F. Calendario de Egresos.xlsx` }
//         ]
//       },
//       {
//         categoria: `III. Ejercicio Presupuestario`,
//         incisos: [
//           { letra: "A.", nombre: "Cuentas Bancarias Productivas Federales", pdf: `${basePath}/III. Ejercicio Presupuestario/a) Cuentas Bancarias Productivas Federales.pdf` },
//           { letra: "B.", nombre: "Ejercicio y Destino del Gasto Federalizado", pdf: `${basePath}/III. Ejercicio Presupuestario/b) Ejercicio y Destino del Gasto Federalizado.pdf` },
//           { letra: "C.", nombre: "Fondo de Aportaciones para la Infraestructura Social", pdf: `${basePath}/III. Ejercicio Presupuestario/c) Fondo de Aportaciones para la Infraestructura Social.pdf` }
//         ]
//       },
//       {
//         categoria: "Criterios Ley de Disciplina Financiera",
//         incisos: [
//           {
//             letra: "Formato 7.-",
//             nombre: `Proyecciones y Resultados de Ingresos y Egresos ${anio}`,
//             subIncisos: [
//               { letra: "a)", nombre: "Proyecciones de Ingresos", pdf: `${basePath}/Criterios Ley de Disciplina Financiera/a) Proyecciones de Ingresos.xlsx` },
//               { letra: "b)", nombre: "Proyecciones de Egresos", pdf: `${basePath}/Criterios Ley de Disciplina Financiera/b) Proyecciones de Egresos.xlsx` },
//               { letra: "c)", nombre: "Resultados de Ingresos", pdf: `${basePath}/Criterios Ley de Disciplina Financiera/c) Resultados de Ingresos.xlsx` },
//               { letra: "d)", nombre: "Resultados de Egresos", pdf: `${basePath}/Criterios Ley de Disciplina Financiera/d) Resultado de Egresos.xlsx` }
//             ]
//           }
//         ]
//       },
//       {
//         categoria: `Matriz de Indicadores para Resultados (MIR) ${anio}`,
//         incisos: [
//           { letra: "a)", nombre: "Metodología", pdf: `${basePath}/Matriz de Indicadores para Resultados (MIR)/a) Metodologia.pdf` },
//           { letra: "b)", nombre: "Programa Anual de Evaluación", pdf: `${basePath}/Matriz de Indicadores para Resultados (MIR)/b) Programa Anual de Evaluaciones.pdf` },
//           { letra: "c)", nombre: "Matriz de Indicadores para Resultados", pdf: `${basePath}/Matriz de Indicadores para Resultados (MIR)/c) Matriz de indicadores para Resultados.pdf` }
//         ]
//       }
//     ];
//   };

//   const crearEstructuraTrimestre = (anio, numTrim, nombreCarpeta, tituloCompleto) => ({
//     id: `${anio}-${numTrim}T`,
//     titulo: tituloCompleto,
//     secciones: crearSeccionesTrimestrales(anio, nombreCarpeta)
//   });

//   const anios = [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018]; //En esta parte simplemente se debe de agregar el año que sigue al principio

//   const ejercicios = anios.map((anio) => ({
//     anio,
//     trimestres: [
//       crearEstructuraTrimestre(anio, 1, "1er Trimestre", "Primer Trimestre (Enero - Marzo)"),
//       crearEstructuraTrimestre(anio, 2, "2do Trimestre", "Segundo Trimestre (Abril - Junio)"),
//       crearEstructuraTrimestre(anio, 3, "3er Trimestre", "Tercer Trimestre (Julio - Septiembre)"),
//       crearEstructuraTrimestre(anio, 4, "4to Trimestre", "Cuarto Trimestre (Octubre - Diciembre)")
//     ],
//     anual: {
//       titulo: `Información Anual ${anio}`,
//       secciones: crearSeccionesAnuales(anio)
//     }
//   }));

//   const renderSecciones = (secciones, idPadre) =>
//     secciones.map((sec, idxSec) => {
//       const idCatUnico = `${idPadre}-cat-${idxSec}`;
//       const estaAbierta = openCategoria === idCatUnico;

//       return (
//         <div key={idxSec} className="mb-3 border rounded bg-white">
//           <div
//             className="p-3 d-flex justify-content-between align-items-center"
//             style={{ cursor: "pointer", backgroundColor: "#fff" }}
//             onClick={() => toggleCategoria(idCatUnico)}
//           >
//             <h6 style={{ color: "#691c32", fontWeight: "bold", margin: 0 }}>
//               {sec.categoria}
//             </h6>
//             <span style={{ fontSize: "12px", color: "#666" }}>
//               {estaAbierta ? "▲ Ocultar" : "▼ Desplegar"}
//             </span>
//           </div>

//           {estaAbierta && (
//             <div className="p-3 border-top" style={{ backgroundColor: "#fafafa" }}>
//               <div className="list-group">
//                 {sec.incisos.map((inciso, idxInc) => (
//                   <React.Fragment key={idxInc}>
//                     {inciso.pdf ? (
//                       <div
//                         onClick={(e) => manejarClicArchivo(e, inciso.pdf, inciso.nombre)}
//                         className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-2"
//                         style={{ fontSize: "14px", borderLeft: "3px solid #d8c39d", cursor: "pointer" }}
//                       >
//                         <span>
//                           <strong className="me-2">{inciso.letra}</strong> {inciso.nombre}
//                         </span>
//                         <span className="badge" style={{ backgroundColor: "#691c32" }}>
//                           {obtenerEtiquetaBadge(inciso.pdf)}
//                         </span>
//                       </div>
//                     ) : (
//                       <div className="list-group-item py-2" style={{ backgroundColor: "#f8f9fa" }}>
//                         <strong className="me-2">{inciso.letra}</strong> {inciso.nombre}
//                         {inciso.subIncisos && (
//                           <div className="list-group mt-2 ms-3">
//                             {inciso.subIncisos.map((sub, idxSub) => (
//                               <div
//                                 key={idxSub}
//                                 onClick={(e) => manejarClicArchivo(e, sub.pdf, sub.nombre)}
//                                 className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-2"
//                                 style={{ fontSize: "13px", borderLeft: "3px solid #691c32", cursor: "pointer" }}
//                               >
//                                 <span>
//                                   <strong className="me-2">{sub.letra}</strong> {sub.nombre}
//                                 </span>
//                                 <span className="badge" style={{ backgroundColor: "#691c32" }}>
//                                   {obtenerEtiquetaBadge(sub.pdf)}
//                                 </span>
//                               </div>
//                             ))}
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </React.Fragment>
//                 ))}
//               </div>
//             </div>
//           )}
//         </div>
//       );
//     });

//   return (
//     <div className="container py-4">
//       <div className="secretaria_funciones">
//         <h3 className="title" style={{ color: "#691c32", fontWeight: "bold" }}>
//           Armonización Contable
//         </h3>
//         <hr className="hr-gob" />
//       </div>

//       <div className="row mt-4">
//         <div className="col-12">
//           {ejercicios.map((ejercicio) => (
//             <div key={ejercicio.anio} className="card shadow-sm border-0 mb-3" style={{ backgroundColor: "#fcfcfc" }}>
//               <div
//                 className="card-header text-white d-flex justify-content-between align-items-center"
//                 style={{ backgroundColor: "#691c32", cursor: "pointer" }}
//                 onClick={() => toggleAnio(ejercicio.anio)}
//               >
//                 <h5 className="mb-0">Ejercicio {ejercicio.anio}</h5>
//                 <span style={{ fontSize: "12px" }}>
//                   {openAnio === ejercicio.anio ? "▲ Ocultar" : "▼ Desplegar"}
//                 </span>
//               </div>

//               {openAnio === ejercicio.anio && (
//                 <div className="card-body p-3">
//                   <div className="d-flex mb-3 gap-2">
//                     <button
//                       className={`btn btn-sm ${
//                         vistaAnio[ejercicio.anio] === "trimestral"
//                           ? "btn-dark"
//                           : "btn-outline-dark"
//                       }`}
//                       onClick={() => cambiarVista(ejercicio.anio, "trimestral")}
//                       style={{
//                         backgroundColor: vistaAnio[ejercicio.anio] === "trimestral" ? "#691c32" : "transparent",
//                         borderColor: "#691c32",
//                         color: vistaAnio[ejercicio.anio] === "trimestral" ? "#fff" : "#691c32"
//                       }}
//                     >
//                       Información Trimestral
//                     </button>
//                     <button
//                       className={`btn btn-sm ${
//                         vistaAnio[ejercicio.anio] === "anual" ? "btn-dark" : "btn-outline-dark"
//                       }`}
//                       onClick={() => cambiarVista(ejercicio.anio, "anual")}
//                       style={{
//                         backgroundColor: vistaAnio[ejercicio.anio] === "anual" ? "#691c32" : "transparent",
//                         borderColor: "#691c32",
//                         color: vistaAnio[ejercicio.anio] === "anual" ? "#fff" : "#691c32"
//                       }}
//                     >
//                       Información Anual
//                     </button>
//                   </div>

//                   {vistaAnio[ejercicio.anio] === "trimestral" && (
//                     <div className="border rounded bg-white">
//                       {ejercicio.trimestres.map((trimestre) => (
//                         <div key={trimestre.id} className="border-bottom">
//                           <div
//                             className="p-3 d-flex justify-content-between align-items-center"
//                             style={{ cursor: "pointer", backgroundColor: "#fff" }}
//                             onClick={() => toggleTrimestre(trimestre.id)}
//                           >
//                             <span className="fw-normal" style={{ fontSize: "16px", color: "#333" }}>
//                               {trimestre.titulo}
//                             </span>
//                             <div>
//                               <span style={{ fontSize: "12px", color: "#666" }}>
//                                 {openTrimestre === trimestre.id ? "▲ Ocultar" : "▼ Desplegar"}
//                               </span>
//                             </div>
//                           </div>

//                           {openTrimestre === trimestre.id && (
//                             <div className="p-4" style={{ backgroundColor: "#f9f9f9", borderTop: "1px solid #eee" }}>
//                               {renderSecciones(trimestre.secciones, trimestre.id)}
//                             </div>
//                           )}
//                         </div>
//                       ))}
//                     </div>
//                   )}

//                   {vistaAnio[ejercicio.anio] === "anual" && (
//                     <div className="p-4 border rounded bg-white">
//                       <h5 className="mb-4" style={{ color: "#691c32", fontWeight: "bold" }}>
//                         {ejercicio.anual.titulo}
//                       </h5>
//                       {renderSecciones(ejercicio.anual.secciones, `${ejercicio.anio}-anual`)}
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* //SECCIÓN FINAL: CALENDARIO ANUAL AUTORIZADO */}
//       <div className="secretaria_funciones mt-5">
//         <h3 className="title" style={{ color: "#691c32", fontWeight: "bold" }}>
//           Calendario Anual Autorizado
//         </h3>
//         <hr className="hr-gob" />
//       </div>

//       <div className="row">
//         {articles.map((article, i) => (
//           <Card
//             key={i}
//             document={"Artículo"}
//             title={article.title}
//             href={article.link}
//             type="PDF"
//             year={article.year}
//           />
//         ))}
//       </div>
//     </div>
//   );
// }

// export default ArmonizacionContable;